import { notFoundRouteCase, route, routerSwitch, Updater } from 'widgets-for-react'
import { SPARedirect } from '../../..'
import { RootState } from '../rootState'
import { Pages, routeUpdaters } from './routesState'
import { Routes } from '../../utils/routes.shared'

const addRedirectUrl = (newUrl: string, oldUrl: string) => {
  // Parse new URL
  const parsedUrl = new URL(window.location.href);
  parsedUrl.pathname = newUrl;
  parsedUrl.searchParams.append("redirectUrl", oldUrl);
  return parsedUrl.pathname + parsedUrl.search
}

export const routesArray = (redirects: SPARedirect[]) => [
    ...redirects.map(redirect => route(
      redirect.OriginalSlug.trim().replace(/\s+/g, '-'),
      (params) => routeUpdaters.redirect.jumpTo({ to: addRedirectUrl(redirect.NewSlug, redirect.OriginalSlug) })
    )),

    routeWidgets.home,

    routeWidgets.englishHome,
    routeWidgets.englishSearch,

    routeWidgets.englishSpaarneTernary,
    routeWidgets.englishSpaarneSecondary,
    routeWidgets.englishSpaarnePrimary,

    routeWidgets.departmentsAndCentraOverview,                    // /afdelingen-en-centra
    routeWidgets.verpleegafdelingenOverview,                     // /verpleegafdelingen
    routeWidgets.friend,                                          // /vrienden/:slug
    routeWidgets.friendHome,                                      // /vrienden

    routeWidgets.subDepartmentOrSpaarne,                          // /afdelingen-en-centra/:centrumSlug/:departmentOrSpaarneSlug/:slug
    routeWidgets.subDepartmentOrDepartmentOrSubCentrumOrSpaarne,  // /afdelingen-en-centra/:departmentOrCentrumSlug/:slug
    routeWidgets.departmentOrCentrum,                             // /afdelingen-en-centra/:slug

    routeWidgets.event,
    routeWidgets.eventOverview,
    routeWidgets.news,
    routeWidgets.newsOverview,
    routeWidgets.newsAndEventsOverview,
    routeWidgets.locationOrSpaarne,
    routeWidgets.specialist,
    routeWidgets.specialistOverview,
    routeWidgets.research,
    routeWidgets.researchOverview,
    routeWidgets.search,
    routeWidgets.folderPage,
    routeWidgets.dossierChildPage, // must precede dossierPage: its :slug also matches slashes
    routeWidgets.dossierPage,
    routeWidgets.folders,
    routeWidgets.waitingTimes,
    routeWidgets.preview,
    routeWidgets.preview,

    //generic pages should be kept in the end of the routes list, because they match every path
    routeWidgets.spaarneTernary,
    routeWidgets.spaarneSecondary,
    routeWidgets.spaarnePrimary,
    routeWidgets.spaarnePrimary,

    notFoundRouteCase<Updater<RootState>>(routeUpdaters.notFound.jumpTo),
]

export const routesWidget = (redirects: SPARedirect[]) =>
  routerSwitch<Updater<RootState>>()(routesArray(redirects))

const routeWidgets: Routes<RootState, Pages> = {
  redirect: route('', () => s => s), // Not used

  notFound: route(routeUpdaters.notFound.url, routeUpdaters.notFound.jumpTo),

  home: route(routeUpdaters.home.url, routeUpdaters.home.jumpTo),

  englishHome: route(routeUpdaters.englishHome.url, routeUpdaters.englishHome.jumpTo),

  spaarnePrimary: route(
    routeUpdaters.spaarnePrimary.url,
    routeUpdaters.spaarnePrimary.jumpTo
  ),

  spaarneSecondary: route(routeUpdaters.spaarneSecondary.url, routeUpdaters.spaarneSecondary.jumpTo),

  spaarneTernary: route(routeUpdaters.spaarneTernary.url, routeUpdaters.spaarneTernary.jumpTo),

  englishSpaarnePrimary: route(routeUpdaters.englishSpaarnePrimary.url, routeUpdaters.englishSpaarnePrimary.jumpTo),

  englishSpaarneSecondary: route(
    routeUpdaters.englishSpaarneSecondary.url,
    routeUpdaters.englishSpaarneSecondary.jumpTo
  ),

  englishSpaarneTernary: route(routeUpdaters.englishSpaarneTernary.url, routeUpdaters.englishSpaarneTernary.jumpTo),

  eventOverview: route(routeUpdaters.eventOverview.url, routeUpdaters.eventOverview.jumpTo),

  newsAndEventsOverview: route(routeUpdaters.newsAndEventsOverview.url, routeUpdaters.newsAndEventsOverview.jumpTo),

  departmentsAndCentraOverview: route(
    routeUpdaters.departmentsAndCentraOverview.url,
    routeUpdaters.departmentsAndCentraOverview.jumpTo
  ),

  verpleegafdelingenOverview: route(
    routeUpdaters.verpleegafdelingenOverview.url,
    routeUpdaters.verpleegafdelingenOverview.jumpTo
  ),

  friend: route(routeUpdaters.friend.url, routeUpdaters.friend.jumpTo),

  friendHome: route(routeUpdaters.friendHome.url, routeUpdaters.friendHome.jumpTo),

  departmentOrCentrum: route(routeUpdaters.departmentOrCentrum.url, routeUpdaters.departmentOrCentrum.jumpTo),

  subDepartmentOrDepartmentOrSubCentrumOrSpaarne: route(
    routeUpdaters.subDepartmentOrDepartmentOrSubCentrumOrSpaarne.url,
    routeUpdaters.subDepartmentOrDepartmentOrSubCentrumOrSpaarne.jumpTo
  ),

  subDepartmentOrSpaarne: route(routeUpdaters.subDepartmentOrSpaarne.url, routeUpdaters.subDepartmentOrSpaarne.jumpTo),

  event: route(routeUpdaters.event.url, routeUpdaters.event.jumpTo),

  newsOverview: route(routeUpdaters.newsOverview.url, routeUpdaters.newsOverview.jumpTo),

  dossierPage: route(routeUpdaters.dossierPage.url, routeUpdaters.dossierPage.jumpTo),

  dossierChildPage: route(routeUpdaters.dossierChildPage.url, routeUpdaters.dossierChildPage.jumpTo),

  news: route(routeUpdaters.news.url, routeUpdaters.news.jumpTo),

  locationOrSpaarne: route(routeUpdaters.locationOrSpaarne.url, routeUpdaters.locationOrSpaarne.jumpTo),

  specialistOverview: route(routeUpdaters.specialistOverview.url, routeUpdaters.specialistOverview.jumpTo),

  specialist: route(routeUpdaters.specialist.url, routeUpdaters.specialist.jumpTo),

  search: route(routeUpdaters.search.url, routeUpdaters.search.jumpTo),

  englishSearch: route(routeUpdaters.englishSearch.url, routeUpdaters.englishSearch.jumpTo),

  folders: route(routeUpdaters.folders.url, routeUpdaters.folders.jumpTo),

  researchOverview: route(routeUpdaters.researchOverview.url, routeUpdaters.researchOverview.jumpTo),

  research: route(routeUpdaters.research.url, routeUpdaters.research.jumpTo),

  waitingTimes: route(routeUpdaters.waitingTimes.url, routeUpdaters.waitingTimes.jumpTo),

  folderPage: route(routeUpdaters.folderPage.url, routeUpdaters.folderPage.jumpTo),

  preview: route(routeUpdaters.preview.url, routeUpdaters.preview.jumpTo),
}
